/**
 * Convercus BI Service
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { KpiParameterColumnDto } from './kpi-parameter-column-dto';


export interface KpiParameterSchema { 
    /**
     * Must match a {{name}} placeholder in the SQL ({{name.from}}/{{name.to}} for a dateRange, {{name.unit}}/{{name.interval}} for a timeGrain).
     */
    name: string;
    type: KpiParameterSchema.TypeEnum;
    required: boolean;
    /**
     * Value bound when none is supplied. A Metabase date string for a dateRange (past90days~), a single day for a date, a TimeGrain for a timeGrain.
     */
    defaultValue?: object;
    /**
     * Static option list for enum-like preview controls.
     */
    allowedValues?: Array<string>;
    /**
     * SELECT producing options (run through safe-query): one column of values, or two columns read as value, label.
     */
    allowedValuesSource?: object;
    /**
     * text, enum and number only: the parameter takes a list of values, rendered as a typed array and used as col = ANY({{name}}). A multi dashboard filter binds only to multiple parameters.
     */
    multiple?: boolean;
    /**
     * column parameters only: the column the generated condition filters ({ sql, dataType }).
     */
    column?: KpiParameterColumnDto;
}
export namespace KpiParameterSchema {
    export const TypeEnum = {
        Date: 'date',
        Enum: 'enum',
        Text: 'text',
        Number: 'number',
        TimeGrain: 'timeGrain',
        DateRange: 'dateRange',
        Column: 'column'
    } as const;
    export type TypeEnum = typeof TypeEnum[keyof typeof TypeEnum];
}


